import process from 'process';

const isBrowser = typeof window !== 'undefined';
const isTest = process.env.NODE_ENV === 'test';

// Get environment variables from the appropriate source.
// Vite replaces `import.meta.env.VITE_*` at build time for client bundles.
// `process.env` is only meaningful in Node (server, tests) — Vite does NOT
// replace it in browser code, so reading process.env here returns undefined.
const getEnv = (key: string, defaultValue: string = ''): string => {
  if (isTest) {
    return process.env[key] || defaultValue;
  }

  if (isBrowser) {
    try {
      const env = (import.meta as { env?: Record<string, string | undefined> }).env;
      const value = env?.[key];
      if (typeof value === 'string' && value.length > 0) return value;
    } catch {
      // import.meta unavailable (legacy CommonJS context)
    }
    return defaultValue;
  }

  return process.env[key] || defaultValue;
};

export const ENV = {
  VITE_API_URL: getEnv('VITE_API_URL', 'http://localhost:8081'),
  NODE_ENV: getEnv('NODE_ENV', 'development'),
  isProd: getEnv('NODE_ENV', 'development') === 'production',
  isDev: getEnv('NODE_ENV', 'development') === 'development',
};

export default ENV;
